import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@vsolv/vectors-ui/button';
import { IconsModule } from '@vsolv/vectors-ui/icons';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { ViewDeclarationButtonComponent } from './view-declaration-button.component';

@NgModule({
  declarations: [ViewDeclarationButtonComponent],
  imports: [CommonModule, ButtonModule, IconsModule, ThemingModule],
  exports: [ViewDeclarationButtonComponent],
})
export class ViewDeclarationButtonModule {}
